import { __assign, __values } from "tslib";
import { createAction } from 'redux-actions';
import { initialState } from './reducers';
import produce from 'immer';
export var setSubsidiesState = createAction('SUBSIDIES/SET_SUBSIDIES_STATE', function (order) {
    return produce(__assign({}, initialState), function (draft) {
        var e_1, _a, e_2, _b, e_3, _c;
        draft.selectSubsidiesError = null;
        try {
            for (var _d = __values(order.travellers), _e = _d.next(); !_e.done; _e = _d.next()) {
                var traveller = _e.value;
                draft.availableSubsidiesByPassengers[traveller.id] = [];
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
            }
            finally { if (e_1) throw e_1.error; }
        }
        try {
            for (var _f = __values(order.travellers), _g = _f.next(); !_g.done; _g = _f.next()) {
                var traveller = _g.value;
                draft.selectedSubsidies[traveller.id] = [];
                if (!traveller.subsidyInfo) {
                    draft.availableSubsidiesByPassengers[traveller.id] = [];
                }
                if (traveller.subsidyInfo) {
                    try {
                        for (var _h = (e_3 = void 0, __values(traveller.subsidyInfo.subsidies)), _j = _h.next(); !_j.done; _j = _h.next()) {
                            var subsidy = _j.value;
                            draft.availableSubsidiesByPassengers[traveller.id].push({
                                id: subsidy.id,
                                type: subsidy.type,
                                name: subsidy.name,
                                description: subsidy.description,
                                validation: subsidy.validation
                            });
                        }
                    }
                    catch (e_3_1) { e_3 = { error: e_3_1 }; }
                    finally {
                        try {
                            if (_j && !_j.done && (_c = _h.return)) _c.call(_h);
                        }
                        finally { if (e_3) throw e_3.error; }
                    }
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
            }
            finally { if (e_2) throw e_2.error; }
        }
    });
});
export var setSubsidiesLoading = createAction('SUBSIDIES/SET_LOADING');
export var setSubsidiesResultsOpen = createAction('SUBSIDIES/SET_RESULTS_OPEN');
export var checkSubsidy = createAction('SUBSIDIES/CHECK_SUBSIDY');
export var setCheckSubsidyResult = createAction('SUBSIDIES/SET_CHECK_SUBSIDY_RESULT');
export var clearSelectedSubsidies = createAction('SUBSIDIES/CLEAR_SELECTED_SUBSIDIES');
export var selectSubsidy = createAction('SUBSIDIES/SELECT_SUBSIDY');
export var setSubsidiesError = createAction('SUBSIDIES/SET_ERROR');
export var selectSubsidies = createAction('SUBSIDIES/SELECT_SUBSIDIES');
